<script setup lang="ts">

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useTaskRelatedCreate } from '../../model/info/task-related-create.hook'

defineOptions({
  name: 'TaskRelatedCreate',
})

const {
  refCanCreateRelatedTask,
  refContainer,
  refFloating,
  refIsOpen,
  refFloatingStyles,
  refTriggerIcon,
  refCreateIcon,
  toggle,
  createRelatedTask,
} = useTaskRelatedCreate()
</script>

<template>
  <div
    ref="refContainer"
    class="task-related-create"
  >
    <BtnIcon
      :icon="refTriggerIcon"
      view="transparent"
      title="Task actions"
      @click="toggle"
    />
    <div
      v-if="refIsOpen"
      ref="refFloating"
      class="task-related-create__floating"
      :style="refFloatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Create Related Task"
          color="blue"
          :prepend-icon="refCreateIcon"
          :disabled="!refCanCreateRelatedTask"
          @click="createRelatedTask"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TaskRelatedCreate.scss" />
